import { SyntheticEvent, useState } from "react";
import axios from "axios";

import { useSelector } from "redux/hooks";
import { getFullUser } from "redux/selectors/user";

import CircleCheckMarkIcon from "components/Icons/circle_check_mark.svg";
import CancelIcon from "components/Icons/circle_x.svg";

const EmailVerificationStatus = () => {
  const user = useSelector(getFullUser);

  const [sendingVerificationEmail, setSendingVerificationEmail] =
    useState(false);
  const [verificationEmailSent, setVerificationEmailSent] = useState(false);
  const [verificationEmailSendingError, setVerificationEmailSendingError] =
    useState(false);

  const sendUserConfirmationEmail = async (e: SyntheticEvent) => {
    e.preventDefault();

    setSendingVerificationEmail(true);
    setVerificationEmailSendingError(false);

    try {
      await axios.post("/api/profile/send-email-verification", { user });

      setVerificationEmailSent(true);
    } catch {
      setVerificationEmailSendingError(true);
    }

    setSendingVerificationEmail(false);
  };

  return (
    <div className="mt-lg">
      {user.isEmailVerified ? (
        <div className="flex text-xs text-default">
          <CircleCheckMarkIcon
            height="18"
            width="18"
            className="inline-block text-green"
          />
          Email verified
        </div>
      ) : (
        <div className="flex justify-between">
          <div className="flex text-xs text-default">
            <CancelIcon
              height="18"
              width="18"
              className="inline-block text-error"
            />
            Email not verified
          </div>

          {sendingVerificationEmail && (
            <div className="text-xs font-bold text-deep-green">sending...</div>
          )}

          {verificationEmailSent && (
            <div className="text-xs font-bold text-green">
              Verification email sent!
            </div>
          )}

          {!verificationEmailSent && !sendingVerificationEmail && (
            <div className="flex">
              {verificationEmailSendingError && (
                <span className="text-xs text-error mr-xs">
                  Error sending email
                </span>
              )}
              <button
                className="button button--text"
                onClick={sendUserConfirmationEmail}
              >
                resend email
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmailVerificationStatus;
